export default {
  "common.save": "Guardar",
  "common.cancel": "Cancelar",
  "common.delete": "Eliminar",
  "common.edit": "Editar",
  "common.add": "Agregar",
  "common.back": "Atrás",
  "common.loading": "Cargando...",
  "common.error": "Algo salió mal",
  "common.success": "Éxito",
  "common.confirm": "Confirmar",
  "common.search": "Buscar",
  "common.filter": "Filtrar",
  "common.all": "Todos",
  "common.comingSoon": "Próximamente",
  "common.noResults": "Sin resultados",
  "common.retry": "Reintentar",

  "auth.login": "Iniciar sesión",
  "auth.signup": "Registrarse",
  "auth.logout": "Cerrar sesión",
  "auth.email": "Correo electrónico",
  "auth.password": "Contraseña",
  "auth.name": "Nombre completo",
  "auth.confirmPassword": "Confirmar contraseña",
  "auth.forgotPassword": "¿Olvidaste tu contraseña?",
  "auth.noAccount": "¿No tienes una cuenta?",
  "auth.haveAccount": "¿Ya tienes una cuenta?",
  "auth.agreeTerms": "Acepto los Términos de servicio y la Política de privacidad",

  "nav.home": "Inicio",
  "nav.payments": "Pagos",
  "nav.add": "Agregar",
  "nav.analytics": "Análisis",
  "nav.profile": "Perfil",
  "nav.allPayments": "Todos los pagos",
  "nav.addPayment": "Agregar pago",
  "nav.subscriptions": "Suscripciones",
  "nav.calendar": "Calendario",
  "nav.documents": "Documentos",
  "nav.settings": "Configuración",
  "nav.personalInfo": "Información personal",
  "nav.changePassword": "Cambiar contraseña",
  "nav.twoFactor": "Autenticación de dos factores",
  "nav.devices": "Dispositivos",
  "nav.reminders": "Recordatorios",
  "nav.editPayment": "Editar pago",
  "nav.paymentDetail": "Detalle del pago",

  "dashboard.title": "Panel",
  "dashboard.greeting": "Buenos días",
  "dashboard.totalDue": "Total pendiente",
  "dashboard.thisMonth": "Este mes",
  "dashboard.upcomingPayments": "Próximos pagos",
  "dashboard.quickStats": "Estadísticas rápidas",
  "dashboard.noUpcoming": "Sin próximos pagos",
  "dashboard.addFirst": "Agrega tu primer pago para comenzar",
  "dashboard.budgetUsed": "Presupuesto usado",

  "payments.title": "Pagos",
  "payments.add": "Agregar pago",
  "payments.edit": "Editar pago",
  "payments.detail": "Detalle del pago",
  "payments.amount": "Monto",
  "payments.dueDate": "Fecha de vencimiento",
  "payments.category": "Categoría",
  "payments.frequency": "Frecuencia",
  "payments.notes": "Notas",
  "payments.status.paid": "Pagado",
  "payments.status.pending": "Pendiente",
  "payments.status.overdue": "Atrasado",
  "payments.markAsPaid": "Marcar como pagado",
  "payments.deleteConfirm": "¿Eliminar este pago?",
  "payments.frequency.once": "Una vez",
  "payments.frequency.weekly": "Semanal",
  "payments.frequency.monthly": "Mensual",
  "payments.frequency.yearly": "Anual",
  "payments.noPayments": "Sin pagos aún",

  "subscriptions.title": "Suscripciones",
  "subscriptions.add": "Agregar suscripción",
  "subscriptions.monthly": "Gasto mensual",
  "subscriptions.active": "Activo",
  "subscriptions.paused": "Pausado",
  "subscriptions.overdue": "Atrasado",
  "subscriptions.nextBilling": "Próxima facturación",
  "subscriptions.billingCycle": "Ciclo de facturación",

  "analytics.title": "Análisis",
  "analytics.spendingByCategory": "Gasto por categoría",
  "analytics.monthlyTrend": "Tendencia mensual",
  "analytics.totalSpent": "Total gastado",
  "analytics.paidThisMonth": "Pagado este mes",
  "analytics.pending": "Pendiente",
  "analytics.noData": "Sin datos para este período",

  "calendar.title": "Calendario",
  "calendar.noPaymentsToday": "Sin pagos en esta fecha",
  "calendar.connectGoogle": "Conectar Google Calendar",
  "calendar.export": "Exportar calendario (.ics)",
  "calendar.openGoogle": "Abrir Google Calendar",
  "calendar.sync": "Sincronización de calendario",

  "documents.title": "Documentos",
  "documents.upload": "Subir documento",
  "documents.noDocuments": "Sin documentos subidos",
  "documents.maxSize": "Máx 10MB — PDF, JPEG, PNG",

  "profile.title": "Perfil",
  "profile.settings": "Configuración",
  "profile.reminders": "Recordatorios",
  "profile.personalInfo": "Información personal",
  "profile.changePassword": "Cambiar contraseña",
  "profile.twoFactor": "Autenticación de dos factores",
  "profile.devices": "Dispositivos",
  "profile.language": "Idioma",
  "profile.currency": "Moneda",
  "profile.deleteAccount": "Eliminar cuenta",
  "profile.plan.free": "Plan gratuito",
  "profile.plan.pro": "Plan Pro",
  "profile.upgradeToPro": "Actualizar a Pro",
  "profile.connectedDevices": "Dispositivos conectados",
  "profile.pendingTill": "Pendiente hasta la fecha",

  "reminders.title": "Preferencias de recordatorio",
  "reminders.daysBefore": "Recordarme antes",
  "reminders.email": "Notificaciones por correo",
  "reminders.push": "Notificaciones push",
  "reminders.sms": "Notificaciones SMS",

  "upgrade.title": "Actualizar a Pro",
  "upgrade.subtitle": "Desbloquea todas las funciones",
  "upgrade.perMonth": "/mes",
  "upgrade.upgrade": "Actualizar ahora",

  "notifications.title": "Notificaciones",
  "notifications.none": "Sin nuevas notificaciones",
  "notifications.viewAll": "Ver todos los pagos",
  "notifications.overdue": "está atrasado",
  "notifications.dueToday": "vence hoy",
  "notifications.dueSoon": "vence en",
  "notifications.days": "días",

  "error.required": "Este campo es obligatorio",
  "error.invalidEmail": "Correo electrónico inválido",
  "error.passwordTooShort": "La contraseña debe tener al menos 6 caracteres",
  "error.passwordMismatch": "Las contraseñas no coinciden",
  "error.networkError": "Error de red. Verifica tu conexión.",
  "error.unauthorized": "Sesión expirada. Inicia sesión de nuevo.",
  "error.notFound": "Página no encontrada",

  "settings.language": "Idioma",
  "settings.selectLanguage": "Seleccionar idioma",
  "settings.selectCurrency": "Seleccionar moneda",
};
